export default __webpack_public_path__ + "static/Tintoberry-426aba7712dfa75ef04af9330852803d.png";